module.exports = __webpack_public_path__ + "47acc3347485bc0c650b064185e6b478.jpg";